export default "__VITE_ASSET__BwS3vu6m__"